"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectTagsInput = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = require("styled-components");
var themes_1 = require("../../../../themes");
var getKeyCode_1 = require("../../../../utils/getKeyCode");
var toArray_1 = require("../../../../utils/toArray");
var utilsOolib_1 = require("../../../../utilsOolib");
var Typo_1 = require("../../../Typo");
var styled_1 = require("../../styled");
var genTagComp_1 = require("../../utils/genTagComp");
var styled_2 = require("./styled");
var SelectTagsInput = function (_a) {
    var 
    //from root
    invert = _a.invert, id = _a.id, value = _a.value, disabled = _a.disabled, 
    // genCustomSelectComp,
    handleSelect = _a.handleSelect, searchString = _a.searchString, setSearchString = _a.setSearchString, placeholder = _a.placeholder, 
    // minHeight, // standard | wide | actual height in rem
    setFocusSelectTagsInput = _a.setFocusSelectTagsInput, focusSelectTagsInput = _a.focusSelectTagsInput, //force focus when after an option is selected in multiselect
    single_multi = _a.single_multi, showOptions = _a.showOptions, S = _a.S, tagColor = _a.tagColor, style = _a.style;
    var inputRef = (0, react_1.useRef)(null);
    var theme = (0, styled_components_1.useTheme)();
    var localize = (0, utilsOolib_1.useLocale)();
    var _b = (0, react_1.useState)(false), isFocussed = _b[0], setIsFocussed = _b[1];
    var handleFocus = function (bool) {
        setIsFocussed(bool);
        if (bool && inputRef.current)
            inputRef.current.focus(); //focus text input
    };
    var blurInputOnEscKey = function (e) {
        var code = (0, getKeyCode_1.getKeyCode)(e);
        if (code === "Escape") {
            inputRef.current.blur();
        }
    };
    (0, react_1.useEffect)(function () {
        if (focusSelectTagsInput) {
            //it gets initiated as 0. which means on first mount this wont run. which is what we want
            handleFocus(true);
        }
    }, [focusSelectTagsInput]);
    var genSelectedTagsTextLabel = function () {
        var TYPO_COMP = S ? Typo_1.SANS_2 : Typo_1.SANS_3;
        return (react_1.default.createElement("div", { style: {
                minHeight: S ? "2rem" : "3rem",
                display: "flex",
                alignItems: "center",
            } },
            react_1.default.createElement(TYPO_COMP, { color: disabled
                    ? themes_1.colors.greyColor40
                    : invert
                        ? themes_1.colors.white
                        : themes_1.colors.greyColor80 }, "".concat(localize('Selected Tags'), ":"))));
    };
    var genSelectComp = function () {
        // const minHeightStyle = minHeight
        //   ? minHeight === "standard"
        //     ? "4rem"
        //     : minHeight === "wide"
        //     ? "9rem"
        //     : minHeight // else use explicit value
        //   : "9rem"; //wide by default
        return (react_1.default.createElement(styled_2.StyledSelectTagsInputContainer, { onKeyDown: blurInputOnEscKey, 
            // style={{ minHeight: '9rem' }}
            style: style, className: "".concat(isFocussed ? "focussed" : ""), invert: invert, disabled: disabled, onFocus: function () {
                handleFocus(true);
            }, onBlur: function () { return handleFocus(false); }, tabIndex: 0 },
            react_1.default.createElement(styled_1.StyledTagsInputWrapper, null,
                genSelectedTagsTextLabel(),
                value &&
                    (0, toArray_1.toArray)(value).map(function (d) {
                        return (0, genTagComp_1.genTagComp)(id, d, {
                            handleSelect: handleSelect,
                            single_multi: single_multi,
                            invert: invert,
                            showOptions: showOptions,
                            theme: theme,
                            S: S,
                            color: tagColor
                        });
                    }),
                //   isCombobox ? (
                react_1.default.createElement(styled_2.StyledTagsSelectTextInput, { ref: inputRef, className: S ? "SANS_2" : "SANS_3", style: { color: invert ? themes_1.colors.white : themes_1.colors.greyColor100 }, placeholder: localize(placeholder || "Type to Search"), type: "text", value: searchString, onBlur: function () {
                        return setFocusSelectTagsInput && setFocusSelectTagsInput(false);
                    }, onChange: function (e) { return setSearchString(e.target.value); } }))));
    };
    return genSelectComp();
};
exports.SelectTagsInput = SelectTagsInput;
